import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classes from "./TemporaryWarning.module.scss";
import cl from "classnames";
import EventEmitter from "eventemitter3";
import CloseButton from "venuescanner-js/react/components/Buttons/CloseButton";

// export const eventNames = {
//   STATUS_CHANGE: 'status_change'
// }

export const TemporaryWarningTrigger = function () {
  this.emitter = new EventEmitter();
  this.events = {
    SHOW: "show",
  };
  this.show = function () {
    this.emitter.emit(this.events.SHOW);
  };
  this.onShow = function (cb) {
    this.emitter.on(this.events.SHOW, cb);
  };
};
const TemporaryWarning = ({
  classname,
  message,
  closeButton = false,
  duration = 2000,
  eventEmitter,
}) => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    eventEmitter.onShow(() => {
      setShow(true);
      setTimeout(() => {
        setShow(false);
      }, duration);
    });
  }, []);
  return (
    <div className={cl(classes["warning"])}>
      {show && closeButton ? (
        <div
          className={classes.blockout}
          onClick={() => {
            setShow(false);
          }}
        >
          &nbsp;
        </div>
      ) : null}
      <div
        className={cl(
          classes["warning-message"],
          { [classes["warning-message-show"]]: show },
          classname
        )}
      >
        {closeButton ? (
          <CloseButton
            classname={classes.closeButton}
            clickHandler={() => {
              setShow(false);
            }}
          />
        ) : null}
        {message}
      </div>
    </div>
  );
};
TemporaryWarning.propTypes = {
  classname: PropTypes.string,
  message: PropTypes.string,
  duration: PropTypes.number,
  closeButton: PropTypes.bool,
  eventEmitter: PropTypes.object,
};

export default TemporaryWarning;
